import { render, staticRenderFns } from "./OrdersByMonthChart.vue?vue&type=template&id=019c8f4b&scoped=true&"
import script from "./OrdersByMonthChart.vue?vue&type=script&lang=js&"
export * from "./OrdersByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c8f4b",
  null
  
)

export default component.exports